export default __webpack_public_path__ + "static/media/967.98b01ee4.gif";